<template>
  <div class="alert" :class="`alert-${styleType}`"><slot /></div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    styleType: {
      default: 'info'
    }
  }
};
</script>
